export const MuiCircularProgress = {
  MuiCircularProgress: {
    root: {
      margin: "auto",
      marginTop: "10px",
      marginBottom: "10px",
    },
  },
};
